var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: _vm.embedded
        ? "result-dialog-embed"
        : ["result-dialog-mask", { "result-dialog-mask--sp": _vm.isSpScreen }],
      attrs: { "aria-label": _vm.dialogTitle },
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onMaskClick.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "result-dialog",
          class: { "result-dialog--embedded": _vm.embedded },
          attrs: {
            role: _vm.embedded ? undefined : "dialog",
            "aria-modal": _vm.embedded ? undefined : "true",
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          !_vm.embedded
            ? _c("div", { staticClass: "result-dialog__header" }, [
                _vm.isSpScreen
                  ? _c(
                      "button",
                      {
                        staticClass: "result-dialog__back",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.$t("assistantCatHome.back"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("close")
                          },
                        },
                      },
                      [_c("icon-arrow-left")],
                      1
                    )
                  : _vm._e(),
                _c("h2", { staticClass: "result-dialog__title" }, [
                  _vm._v(_vm._s(_vm.dialogTitle)),
                ]),
                !_vm.isSpScreen
                  ? _c(
                      "button",
                      {
                        staticClass: "result-dialog__close",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.$t("common.close"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("close")
                          },
                        },
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×"),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "result-dialog__body" },
            [
              _vm.isSpScreen
                ? _c("assistant-cat-home-work-select-prompt", {
                    staticClass: "result-dialog__message",
                    attrs: {
                      message: _vm.headerMessage,
                      "writer-type": _vm.assist.writerType,
                      variant: "page",
                      plain: "",
                    },
                  })
                : _c("chat-message", {
                    staticClass: "result-dialog__message",
                    attrs: {
                      message: _vm.headerMessage,
                      "cat-icon-size": "medium",
                      "writer-type": _vm.assist.writerType,
                      surface: "",
                    },
                  }),
              _c("div", { staticClass: "result-dialog__feedback" }, [
                _c(
                  "div",
                  {
                    ref: "feedbackHtmlRoot",
                    staticClass: "result-dialog__feedback-text",
                    class: { "is-html": _vm.isHtml },
                  },
                  [
                    _vm.isHtml
                      ? _c("div", {
                          domProps: {
                            innerHTML: _vm._s(_vm.$sanitize(_vm.resultText)),
                          },
                        })
                      : _c("div", [_vm._v(_vm._s(_vm.resultText))]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "result-dialog__actions" }, [
                _vm.canApplyThemeGenerate
                  ? _c(
                      "button",
                      {
                        staticClass: "result-dialog__apply-button",
                        attrs: {
                          type: "button",
                          disabled: _vm.isApplyingThemeGenerate,
                        },
                        on: { click: _vm.handleApplyThemeGenerate },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.isApplyingThemeGenerate
                                ? _vm.$t("themeGenerate.apply.applying")
                                : _vm.$t("themeGenerate.apply.button")
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "button",
                  {
                    staticClass: "result-dialog__back-button",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.showBackToListLabel
                            ? _vm.$t("assistantCatHome.result.backToList")
                            : _vm.$t("common.close")
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "result-dialog__notice" }, [
                _c("p", { staticClass: "result-dialog__notice-text" }, [
                  _vm._v(_vm._s(_vm.$t("assistantCatHome.result.historyNote"))),
                ]),
                _vm.isMatchingThemeResult
                  ? _c("p", { staticClass: "result-dialog__notice-text" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("themeMatching.result.disclaimerRecruitment")
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                _vm.isGenerateThemeResult
                  ? _c("p", { staticClass: "result-dialog__notice-text" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("themeGenerate.apply.notice")) + " "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }